import React from 'react'

const shieldOutlineIcon = () => {
	return (
		<svg width='66' height='72' viewBox='0 0 66 72' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M32.4822 1.68907C32.4889 1.68573 32.4957 1.68241 32.5024 1.67912C32.5091 1.68241 32.5158 1.68573 32.5226 1.68907C32.981 1.91465 33.6512 2.23687 34.5078 2.6285C36.2206 3.41154 38.6814 4.47322 41.6876 5.595C47.4033 7.72778 55.1303 10.0928 63.4592 11.1582C63.4674 11.3636 63.4752 11.5936 63.482 11.8468C63.5154 13.0923 63.524 14.899 63.4229 17.1225C63.2205 21.5734 62.5795 27.6733 60.8297 34.2756C57.3707 47.3272 49.6271 62.1972 32.5024 70.344C15.3776 62.1972 7.63408 47.3272 4.17505 34.2756C2.42526 27.6733 1.78425 21.5734 1.58186 17.1225C1.48075 14.899 1.48933 13.0923 1.52277 11.8468C1.52956 11.5936 1.53739 11.3636 1.54552 11.1582C9.87445 10.0928 17.6015 7.72778 23.3171 5.595C26.3234 4.47322 28.7842 3.41154 30.497 2.6285C31.3536 2.23687 32.0237 1.91465 32.4822 1.68907Z'
				stroke='currentColor'
				strokeWidth='3'
			/>
		</svg>
	)
}

export default shieldOutlineIcon
